export default __webpack_public_path__ + "static/media/avatar15-mujer.96748b0e.png";